import { api } from '../../../services/api/axios';
import { authService } from '../../auth/services/authService';

export interface OrderItemAttribute {
  name: string;
  value: string;
}

export interface OrderItem {
  product_id: number;
  name: string;
  price: string;
  quantity: number;
  image: string;
  attributes?: OrderItemAttribute[];
}

export interface OrderTimeline {
  label: string;
  date: string;
}

export interface OrderBilling {
  first_name: string;
  last_name: string;
  email: string;
  phone: string;
  address_1: string;
  address_2: string;
  city: string;
  postcode: string;
  country: string;
}

export interface OrderTracking {
  tracking_number: string;
  carrier: string;
  tracking_url: string;
}

export interface Order {
  order_id: number;
  order_number?: string;
  status: string;
  date: string;
  date_created?: string;
  total: string;
  subtotal?: string;
  currency: string;
  payment_method?: string;
  items: OrderItem[];
  billing?: OrderBilling;
  shipping?: OrderBilling;
  timeline: OrderTimeline[];
  tracking?: OrderTracking;
}

export interface OrdersResponse {
  success: boolean;
  orders: Order[];
}

export const orderService = {
  getOrders: async (): Promise<OrdersResponse> => {
    const token = authService.getToken();
    try {
      const response = await api.get('/orders', {
        headers: { Authorization: `Bearer ${token}` },
      });
      return response.data;
    } catch (err: any) {
      const apiMessage = err.response?.data?.message || err.response?.data?.error;
      throw new Error(apiMessage || err.message);
    }
  },

  getOrderById: async (id: string): Promise<Order> => {
    const token = authService.getToken();
    try {
      const response = await api.get(`/orders/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      return response.data.order;
    } catch (err: any) {
      const apiMessage = err.response?.data?.message || err.response?.data?.error;
      throw new Error(apiMessage || err.message);
    }
  },
};
